import { useCallback, useState } from 'react';

function Captcha() {
  const CHARACTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const randomLetter = (letter) =>
    letter.concat(CHARACTERS.charAt(Math.floor(Math.random() * CHARACTERS.length)));

  const captchaArray = [
    { id: 1, value: '' },
    { id: 2, value: '' },
    { id: 3, value: '' },
    { id: 4, value: '' },
    { id: 5, value: '' },
    { id: 6, value: '' },
  ];

  return {
    createCaptcha: () => captchaArray.map((s) => ({ ...s, value: randomLetter(s.value) })),
  };
}

function useCaptcha() {
  const captcha = Captcha();
  const [keys, setKeys] = useState(captcha.createCaptcha());

  const reload = useCallback(() => {
    setKeys(captcha.createCaptcha());
  }, []);

  const isEqual = useCallback((value) => value === keys.map((s) => s.value).join(''), [keys]);

  return {
    keys,
    reload,
    isEqual,
  };
}

export default useCaptcha;
